import React from 'react';
import { howItWorks } from '../../mock/mock';
import { UserCirclePlus, NotePencil, Palette, HeartStraight } from '@phosphor-icons/react';
import AppIcon from '../AppIcon';

const STEP_ICONS = [[UserCirclePlus, 'rose'], [NotePencil, 'gold'], [Palette, 'lavender'], [HeartStraight, 'wine']];

export default function HowItWorks() {
  return (
    <section id="how" className="py-24 lg:py-32 bg-[#F6EAE0]">
      <div className="max-w-6xl mx-auto px-6 lg:px-10">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <p className="section-eyebrow">How it works</p>
          <h2 className="font-serif text-4xl lg:text-5xl mt-3 text-[#2A2A2A]">
            Four small steps to feel <span className="italic text-[#7B2C3B]">in control</span> again.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-4">
          {howItWorks.map((s, i) => (
            <div
              key={s.step}
              data-testid={`how-step-${s.step}`}
              className="group relative soft-card rounded-2xl p-7 hover:translate-y-[-3px] transition-transform"
            >
              <AppIcon icon={STEP_ICONS[i][0]} tone={STEP_ICONS[i][1]} size="md" interactive reveal delay={i * 100} className="mb-4" />
              <span className="font-serif text-5xl text-[#F4D6CE] absolute top-4 right-5 leading-none">
                0{s.step}
              </span>
              <h3 className="font-serif text-2xl text-[#2A2A2A] mb-3 relative">{s.title}</h3>
              <p className="text-sm text-[#4A4A4A] leading-relaxed">{s.text}</p>
              {i < howItWorks.length - 1 && (
                <div className="hidden lg:block absolute top-1/2 -right-2.5 w-5 h-px bg-[#B8896C]" />
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
